"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var core_1 = require("@material-ui/core");
var dealerDetailsStyles_1 = require("./dealerDetailsStyles");
var SelectDealerButton_1 = require("../../buttons/selectDealerButton/SelectDealerButton");
var DealerDistance_1 = require("./dealerDistance/DealerDistance");
var DealerDetails = function (_a) {
    var dealer = _a.dealer, orderId = _a.orderId, isSelected = _a.isSelected, selectDealerId = _a.selectDealerId, disableDealerSelection = _a.disableDealerSelection;
    var styles = dealerDetailsStyles_1.default();
    var fieldRef = react_1.useRef(null);
    react_1.useEffect(function () {
        isSelected && fieldRef.current.scrollIntoView({ block: 'end' });
    }, []);
    return (<div className={styles.dealerDetailsContainer} ref={fieldRef}>
      <core_1.Box flexGrow={1}>
        <core_1.Box className={styles.dealerDetails}>
          <core_1.Typography variant={'subtitle2'} className={styles.dealerName} data-test={'text:dealer:name'}>
            {++orderId + ". " + dealer.label}
          </core_1.Typography>
          <core_1.Typography variant={'body2'} component={'div'} data-test={'text:dealer:streetName'} className={styles.dealerAddress}>
            {dealer.address.address}
          </core_1.Typography>
          <core_1.Typography variant={'body2'} component={'div'} data-test={'text:dealer:city'} className={styles.dealerCity}>
            {dealer.address.city}
          </core_1.Typography>
        </core_1.Box>
      </core_1.Box>
      <core_1.Box display="flex" flexDirection="column">
        <DealerDistance_1.default dealer={dealer}/>
        <SelectDealerButton_1.default isSelected={isSelected} onClick={function () { return selectDealerId(dealer.externalId); }} testId={"dealer:select:button_" + dealer.externalId + "_" + isSelected} disableDealerSelection={disableDealerSelection}/>
      </core_1.Box>
    </div>);
};
exports.default = DealerDetails;
